import { createSelector } from 'reselect';
import { BookingPageModel } from '@/typings/models/BookingPage';


const selectBookingPagesState = (state: DefaultRootState) => state.bookingPages;
const selectLoadingState = (state: DefaultRootState) => state.loading;

export const selectBookingPages = createSelector(
  [selectBookingPagesState],
  (bookingPages) => bookingPages
);

export const selectBookingPageList = createSelector(
  [selectBookingPagesState],
  (bookingPages): BookingPageModel[] =>
    bookingPages?.bookingPageList || [],
);

export const selectBookingPageDrawer = createSelector(
  [selectBookingPagesState],
  (bookingPages) => bookingPages?.bookingPageDrawer
);

export const selectFetchBookingPagesLoading = createSelector(
  [selectLoadingState],
  (loading) => loading?.effects?.['bookingPages/fetchBookingPages']
);
